import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { formatPrice } from 'utils';
import discount from 'assets/img/discount.png';
import ColorSquare from './ColorSquare';

import './style.scss';

const ProductCard = ({
  id,
  img,
  name,
  price,
  saleAmount,
  properties: {
    size,
    color,
  },
}) => (
  <Link to={`/product/${id}`} className="product-card" style={{ backgroundImage: `url(https://shop.yartf.ru/images/${img}.png)` }}>
    {saleAmount ? <img className="product-card__discount" alt="Акция" src={discount} /> : ''}
    <div className="product-card__text">
      <div className="product-card__text__main">
        <span>{name}</span>
        <span className={saleAmount ? 'product-card__text__price' : ''}>
          {saleAmount ? <span className="product-card__text__price__old">{formatPrice(price)}</span> : ''} {formatPrice(price - saleAmount)} руб.
        </span>
        <span className="product-card__text__size">
          {size.map(item => item.name).join('/')}
        </span>
      </div>
      <div className="product-card__text__colors">
        {color.map((clr, i) => (i < 3) && <ColorSquare key={clr.id} color={clr.rgb} />)}
      </div>
    </div>
  </Link>
);

ProductCard.propTypes = {
  id: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  saleAmount: PropTypes.number.isRequired,
  properties: PropTypes.shape({
    size: PropTypes.array.isRequired,
    color: PropTypes.array.isRequired,
  }).isRequired,
};

export default ProductCard;



// WEBPACK FOOTER //
// ./src/components/ui/ProductCard/index.js